import { PylotFrontendConfig } from 'config'
import { getFormattedDate } from '@corratech/pylot-utils'

/**
 * @see https://schema.org/priceValidUntil
 * We set this value to 2 weeks ahead by default
 *
 * @param config
 * @param days
 */
export const getPriceValidUntil = (
    config: PylotFrontendConfig,
    days?: number
): string => {
    const currentDate = new Date()

    const validUntilDays =
        days ?? config.seo.product.price?.validUntilDays ?? 14
    const expirationTime = validUntilDays * 24 * 60 * 60 * 1000
    currentDate.setTime(currentDate.getTime() + expirationTime)

    return getFormattedDate(currentDate.toString())
}
